module.exports = __webpack_public_path__ + "fonts/Roboto-400-latin-ext38.a6323dd.woff2";